var _style, _g, _pattern, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquare3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97.3 97.3",
    style: {
      enableBackground: "new 0 0 97.3 97.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#858589;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#E2DEDE;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st5{fill:#FA9A63;}\n\t.st6{fill:#FADC63;}\n\t.st7{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st8{fill:url(#);stroke:#000000;stroke-miterlimit:10;}\n\t.st9{fill:url(#SVGID_1_);stroke:#000000;stroke-miterlimit:10;}\n\t.st10{fill:url(#SVGID_00000128465370399155611670000002621516842210568087_);stroke:#000000;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st12{fill:#FFFFFF;}\n\t.st13{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("pattern", {
    x: -1484,
    y: -724.2,
    width: 177.9,
    height: 214.7,
    patternUnits: "userSpaceOnUse",
    id: "New_Pattern_3",
    viewBox: "18.1 -226.1 177.9 214.7",
    style: {
      overflow: "visible"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.1,
    y: -226.1,
    className: "st0",
    width: 177.9,
    height: 214.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.9-16.8c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.5-20.8c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M185.7-28.8c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.7-28.8c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: -12.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.6,
    cy: -27.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.3-18.3c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.4-16.8c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121-20.8c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M141.2-28.8c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.2-28.8c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 146.6,
    cy: -12.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.2,
    cy: -27.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.9-18.3c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.9-16.8c2.3-1.5,6.6,1.1,9.5,5.7S98-1.5,95.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.5-20.8c4.3,3.4,5,9.6,1.7,13.9c-3.4,4.3-9.6,5-13.9,1.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.8-28.8c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.7-28.8c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 102.1,
    cy: -12.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7,
    cy: -27.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.4-18.3c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.5-16.8c2.3-1.5,6.6,1.1,9.5,5.7S53.5-1.5,51.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.1-20.8c4.3,3.4,5,9.6,1.7,13.9c-3.4,4.3-9.6,5-13.9,1.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.3-28.8c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.3-28.8c-2.6,4.8-8.6,6.6-13.4,4s-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: -12.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.2,
    cy: -27.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.9-18.3c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M185-70.5c2.3-1.5,6.6,1.1,9.5,5.7s3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.6-74.4c4.3,3.4,5,9.6,1.7,13.9c-3.4,4.3-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 175.5,
    y1: -49.3,
    x2: 185.8,
    y2: -59.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M204.3-43.8c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.3-43.8c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M196.8-82.5c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.8-82.5c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 165.8,
    cy: -48.9,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.7,
    cy: -81.4,
    r: 3.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140.5-70.5c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.1-74.4c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 131.1,
    y1: -49.3,
    x2: 141.4,
    y2: -59.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M159.9-43.8c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.8-43.8c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M152.4-82.5c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.3-82.5c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 121.4,
    cy: -48.9,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.7,
    cy: -66.3,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.3,
    cy: -81.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158-71.9c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.1-70.5c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.6-74.4c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 86.6,
    y1: -49.3,
    x2: 96.9,
    y2: -59.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M115.4-43.8c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.4-43.8c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.9-82.5c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.8-82.5c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 76.9,
    cy: -48.9,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.2,
    cy: -66.3,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.8,
    cy: -81.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.5-71.9c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.6-70.5c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.2-74.4c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 42.1,
    y1: -49.3,
    x2: 52.4,
    y2: -59.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.9-43.8c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.9-43.8c-2.6,4.8-8.6,6.6-13.4,4s-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.4-82.5c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.4-82.5c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 32.4,
    cy: -48.9,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.7,
    cy: -66.3,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.3,
    cy: -81.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69-71.9c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.1-70.5c2.3-1.5,6.6,1.1,9.5,5.7s3.5,9.6,1.2,11.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.5-43.8c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.4-43.8c-2.6,4.8-8.6,6.6-13.4,4s-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19-82.5c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.9-82.5c-2.6,4.8-8.6,6.6-13.4,4C0.6-81-1.2-87,1.4-91.9"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3,
    cy: -66.3,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.6-71.9c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.7-128.1c4.3,3.4,5,9.6,1.7,13.9c-3.4,4.3-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 186.7,
    y1: -103,
    x2: 196.9,
    y2: -113.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.9-136.1c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.9-136.1c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 176.9,
    cy: -102.6,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.9,
    cy: -135.1,
    r: 3.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M151.6-124.1c2.3-1.5,6.6,1.1,9.5,5.7s3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.2-128.1c4.3,3.4,5,9.6,1.7,13.9c-3.4,4.3-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 142.2,
    y1: -103,
    x2: 152.5,
    y2: -113.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M171-97.5c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9-97.5c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M163.5-136.1c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.4-136.1c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: -102.6,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.8,
    cy: -120,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.4,
    cy: -135.1,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.1-125.6c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.2-124.1c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.8-128.1c4.3,3.4,5,9.6,1.7,13.9c-3.4,4.3-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 97.7,
    y1: -103,
    x2: 108,
    y2: -113.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M126.5-97.5c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.5-97.5c-2.6,4.8-8.6,6.6-13.4,4s-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M119-136.1c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119-136.1c-2.6,4.8-8.6,6.6-13.4,4s-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: -102.6,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.3,
    cy: -120,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.9,
    cy: -135.1,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.6-125.6c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.7-124.1c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.3-128.1c4.3,3.4,5,9.6,1.7,13.9c-3.4,4.3-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 53.3,
    y1: -103,
    x2: 63.5,
    y2: -113.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.1-97.5c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82-97.5c-2.6,4.8-8.6,6.6-13.4,4s-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.5-136.1c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.5-136.1c-2.6,4.8-8.6,6.6-13.4,4s-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: -102.6,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.9,
    cy: -120,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: -135.1,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.2-125.6c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.2-124.1c2.3-1.5,6.6,1.1,9.5,5.7s3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 8.8,
    y1: -103,
    x2: 19.1,
    y2: -113.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.6-97.5c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.5-97.5c-2.6,4.8-8.6,6.6-13.4,4s-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.1-136.1c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30-136.1c-2.6,4.8-8.6,6.6-13.4,4s-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 35.4,
    cy: -120,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.7-125.6c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.8-181.8c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 188.1,
    cy: -156.3,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: -188.7,
    r: 3.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.8-177.8c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.3-181.8c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 153.3,
    y1: -156.6,
    x2: 163.6,
    y2: -166.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182.1-151.1c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.1-151.1c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M174.6-189.8c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5-189.8c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 143.6,
    cy: -156.3,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.9,
    cy: -173.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: -188.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.2-179.3c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M118.3-177.8c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.9-181.8c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 108.8,
    y1: -156.6,
    x2: 119.1,
    y2: -166.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M137.6-151.1c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.6-151.1c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.1-189.8c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.1-189.8c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 99.1,
    cy: -156.3,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.4,
    cy: -173.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: -188.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.7-179.3c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.8-177.8c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.4-181.8c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 64.4,
    y1: -156.6,
    x2: 74.7,
    y2: -166.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M93.2-151.1c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.1-151.1c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.7-189.8c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.6-189.8c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 54.7,
    cy: -156.3,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: -173.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.6,
    cy: -188.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.3-179.3c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.4-177.8c2.3-1.5,6.6,1.1,9.5,5.7s3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.9-181.8c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 19.9,
    y1: -156.6,
    x2: 30.2,
    y2: -166.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.7-151.1c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.7-151.1c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.2-189.8c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.1-189.8c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: -173.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.8-179.3c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.9-231.5c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.5-235.4c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 164.4,
    y1: -210.3,
    x2: 174.7,
    y2: -220.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M193.2-204.8c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.2-204.8c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 154.7,
    cy: -209.9,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: -227.3,
    r: 3.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.4-231.5c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121-235.4c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 120,
    y1: -210.3,
    x2: 130.2,
    y2: -220.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M148.8-204.8c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.7-204.8c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 110.2,
    cy: -209.9,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.6,
    cy: -227.3,
    r: 3.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.9-231.5c2.3-1.5,6.6,1.1,9.5,5.7s3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.5-235.4c4.3,3.4,5,9.6,1.7,13.9c-3.4,4.3-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 75.5,
    y1: -210.3,
    x2: 85.8,
    y2: -220.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.3-204.8c-1.3,2.4-6.3,2.2-11.1-0.4c-4.9-2.6-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.2-204.8c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 65.8,
    cy: -209.9,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.1,
    cy: -227.3,
    r: 3.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.5-231.5c2.3-1.5,6.6,1.1,9.5,5.7s3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.1-235.4c4.3,3.4,5,9.6,1.7,13.9c-3.4,4.3-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 31,
    y1: -210.3,
    x2: 41.3,
    y2: -220.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.8-204.8c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.8-204.8c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 21.3,
    cy: -209.9,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: -227.3,
    r: 3.2
  }))))), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_1_",
    xlinkHref: "#New_Pattern_3",
    patternTransform: "matrix(1 0 0 1 261.8661 89.9753)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st9",
    width: 96.3,
    height: 96.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare3);
export default __webpack_public_path__ + "static/media/Square3.1917793a7d227419ca8682422dc240d8.svg";
export { ForwardRef as ReactComponent };